import { useDrag } from 'react-dnd';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '../../../components';
import { Icons } from '../../icon/icons';
import { GridBlockType } from 'services/entities/BlockTypes';
import './blockSourceButton.less';

const { IcoDrag, IcoImage } = Icons;

const ImageBlockButton = () => {
  const { t } = useTranslation();
  const [{ isDragging }, drag] = useDrag(() => ({
    type: GridBlockType.IMAGE,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    item: {},
  }));

  return (
    <button ref={drag} draggable className="block-source" style={{ opacity: isDragging ? 0.5 : 1 }}>
      <div className="block-source-icon">
        <IcoImage />
      </div>
      <div className="block-source-drag-icon">
        <IcoDrag />
      </div>
      <Paragraph size="sm">{t('editor.toolbar.image')}</Paragraph>
    </button>
  );
};

export default ImageBlockButton;
ImageBlockButton.displayName = 'ImageBlockButton';
